const CLIENT_ID_DISPLAY_NAMES: Record<string, string> = {
  langhub: 'LangHub',
  'langhub-cms': 'LangHub',
  ast: 'AST',
};

/**
 * Maps a raw clientId to a human-readable display name.
 * Known IDs: 'langhub' | 'langhub-cms' → 'LangHub', 'ast' → 'AST'.
 * Unknown IDs are returned with the first character capitalized.
 */
export function getClientDisplayName(clientId: string): string {
  const known = CLIENT_ID_DISPLAY_NAMES[clientId.toLowerCase()];
  if (known) {
    return known;
  }
  return clientId.charAt(0).toUpperCase() + clientId.slice(1);
}

/**
 * Returns true when the string group is owned by LangHub itself and is
 * therefore editable in this UI. String groups owned by other clients
 * (e.g. AST) are surfaced read-only, so their edit operations are disabled.
 *
 * Uses the display-name mapping as the single source of truth so all LangHub
 * client variants ('langhub', 'langhub-cms', and any casing) are treated the
 * same as the rest of the app.
 */
export function isLangHubClient(clientId: string): boolean {
  return getClientDisplayName(clientId) === 'LangHub';
}
